<div
  class="wrapper"
  *ngIf="specialBuildingInfoForm"
  [formGroup]="specialBuildingInfoForm"
>
  <div class="section">
    <div class="special-flag">
      <p-checkbox
        #cbh
        binary="true"
        disabled="true"
        formControlName="specialBuilding"
      ></p-checkbox>
      <div i18n="@@general.specialBuildingFlag" class="label">
        Special building flag
      </div>
    </div>
    <ng-container *ngFor="let category of specialBuildingCategories | keyvalue">
      <div class="sub-title">{{ category.key }}</div>
      <div class="section question-section">
        <div class="questions">
          <div class="form-line" *ngFor="let reason of category.value">
            <p-checkbox
              #cbh
              binary="true"
              [formControlName]="reason.formControlName"
              [label]="reason.description"
            ></p-checkbox>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="sub-title" i18n="@@general.remarks">Remarks</div>
    <div class="section remarks-section">
      <textarea
        [readonly]="!this.isAuthCanWrite"
        placeholder="add remarks"
        formControlName="specialBuildingRemark"
        maxlength="300"
      ></textarea>
    </div>
  </div>
</div>
